import React from 'react';
import { useTranslation } from '../utils/translations';
import { getPhoneUrl, getEmailUrl } from '../utils/contactHelpers';
import InstagramIcon from '../components/InstagramIcon/InstagramIcon';
import {
  OFFICE_NAME,
  OFFICE_ADDRESS,
  OFFICE_PHONE,
  OFFICE_EMAIL,
  OFFICE_MAP_URL,
  OFFICE_MAP_EMBED,
  OFFICE_INSTAGRAM_URL,
  OFFICE_FACEBOOK_URL,
} from '../constants/officeContact';
import './OfficesPage.css';

const OfficesPage = () => {
  const { t } = useTranslation();

  return (
    <div className="offices-page">
      <div className="container">
        <div className="offices-header">
          <h1>{t('offices.title')}</h1>
          <p className="offices-subtitle">{t('offices.subtitle')}</p>
        </div>

        <div className="offices-content">
          <div className="offices-info-card">
            <h2>{OFFICE_NAME}</h2>

            <div className="offices-detail">
              <span className="offices-detail-label">{t('offices.address')}</span>
              <p>{OFFICE_ADDRESS}</p>
            </div>

            <div className="offices-detail">
              <span className="offices-detail-label">{t('offices.phone')}</span>
              <a href={getPhoneUrl(OFFICE_PHONE)} className="offices-contact-link">
                {OFFICE_PHONE}
              </a>
            </div>

            <div className="offices-detail">
              <span className="offices-detail-label">{t('offices.email')}</span>
              <a href={getEmailUrl(OFFICE_EMAIL)} className="offices-contact-link">
                {OFFICE_EMAIL}
              </a>
            </div>

            <div className="offices-social">
              <a
                href={OFFICE_INSTAGRAM_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="offices-social-link"
              >
                <InstagramIcon />
                {t('footer.instagram')}
              </a>
              <a
                href={OFFICE_FACEBOOK_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="offices-social-link"
              >
                <span className="offices-facebook-icon" aria-hidden="true">f</span>
                {t('footer.facebook')}
              </a>
            </div>
          </div>

          <div className="offices-map-card">
            <h2>{t('offices.location')}</h2>
            <div className="offices-map">
              <iframe
                title={t('offices.location')}
                src={OFFICE_MAP_EMBED}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
              />
            </div>
            <p className="offices-map-address">{OFFICE_ADDRESS}</p>
            <a
              href={OFFICE_MAP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="offices-map-link"
            >
              {t('offices.openInMaps')}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OfficesPage;
